module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/LTrack.6a4535e9.svg";